interface CacheStore {
  has: (key: string) => boolean;
  set<T>(key: string, value: T): void;
  get(key: string): any;
}

export default function useStorageStore(): CacheStore {
  return {
    has(key: string) {
      return localStorage.getItem(key) !== null;
    },
    set<T>(key: string, value: T) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    get(key: string) {
      const value = localStorage.getItem(key);
      return value !== null ? JSON.parse(value) : null;
    },
  };
}
